/* eslint-disable jsx-a11y/anchor-is-valid */
// Dependencies
import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// images
import logo from '../../sass/images/logo_navbar.png';
import icono2 from '../../sass/images/icons/icono-historial-white.svg';
import icono3 from '../../sass/images/icons/icono-awesome-handshake.svg';
import icono4 from '../../sass/images/menuMovil/icon_ionic_ios_document.svg';
import icono5 from '../../sass/images/menuMovil/icon_feather_book_open.svg';
import perfil from '../../sass/images/img-usuario-perfil.svg';
import closeWhite from '../../sass/images/icons/icon_exit_white.svg';
import approveCancelWhite from '../../sass/images/icons/approve_cancel-white.svg';
import requestVehicleRegisWhite from '../../sass/images/icons/request_vehicle_regis_white.svg';
import requestDriverRegisWhite from '../../sass/images/icons/request_driver_regis_white.svg';
import downloadReportWhite from '../../sass/images/icons/download_report_white.svg';
import requestMaintenanceWhite from '../../sass/images/icons/request-maintenance-white.svg';
import schedulingWhite from '../../sass/images/icons/scheduling_icon_white.svg';
import dashboardWhite from '../../sass/images/icons/dashboard_white.svg';
import alertMenu from '../../sass/images/icons/alert-mobile.svg';
import userWhite from '../../sass/images/icons/user_white.svg';

// Hooks
import useLanguage from '../hooks/useLanguage';
import useTermsAndConditions from '../hooks/useTermsAndConditions';
import useToggleMenu from '../hooks/useToggleMenu';
import useLogin from '../hooks/useLogin';

function InternalMenuCompany(props) {
  const { t, newMaintenances } = props;
  const { handleChangeToggle } = useToggleMenu();
  const { isEnglish, changeLanguage, locale } = useLanguage();
  const { termAndCondition, termPoliticsPrivate } = useTermsAndConditions();
  const { rolId, logout } = useLogin({});
  return (
    <Navbar
      className="navBarMenu internal-content"
      expand="lg"
      onToggle={(toggle) => handleChangeToggle(toggle)}
    >
      <Link to={`/${locale}/${t('routers:CompanyDashboard')}`}>
        <img src={logo} className="logoMenu" alt={t('alt:logo')} />
      </Link>
      <Nav className="mr-auto mobile">
        <Link
          to={`/${locale}/${t('routers:Profile')}`}
          className={` mobile login-images ${
            newMaintenances > 0 ? 'perfil-notification-movil' : ''
          }`}
        >
          <img src={perfil} alt={t('alt:perfil_company')} />
        </Link>
      </Nav>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="company-menu">
        <Nav className="mr-auto">
          <Link
            to={`/${locale}/${t('routers:PlansCompany')}`}
            className="desktop membership textButton"
          >
            {t('plans-txt')}
          </Link>
          <Link to={`/${locale}/${t('routers:BenefitsCompany')}`} className="desktop loginButton">
            {t('benefits')}
          </Link>
          <Link
            to={`/${locale}/${t('routers:Profile')}`}
            className={` desktop perfil_button ${newMaintenances > 0 ? 'perfil-notification' : ''}`}
          >
            <img src={perfil} alt={t('alt:perfil_company')} />
          </Link>
          <button
            type="button"
            onClick={() => {
              changeLanguage('en');
            }}
            className={
              isEnglish ? 'desktop leguajeButton langEn' : 'desktop leguajeButton langEnOff'
            }
          >
            Eng
          </button>

          <button
            type="button"
            onClick={() => {
              changeLanguage('es');
            }}
            className={
              !isEnglish
                ? 'desktop leguajeButton second langEs'
                : 'desktop leguajeButton second langEsOff'
            }
          >
            Esp
          </button>
          {/* MOVIL */}
          <div className="button_language">
            <button
              type="button"
              onClick={() => {
                changeLanguage('en');
              }}
              className={
                isEnglish ? 'mobile leguajeButton langEn' : 'mobile leguajeButton langEnOff'
              }
            >
              Eng
            </button>

            <button
              type="button"
              onClick={() => {
                changeLanguage('es');
              }}
              className={
                !isEnglish
                  ? 'mobile leguajeButton second langEs'
                  : 'mobile leguajeButton second langEsOff'
              }
            >
              Esp
            </button>
          </div>
          <div className="mobilecontent internal">
            <Link to={`/${locale}/${t('routers:CompanyDashboard')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={dashboardWhite} alt={t('alt:dashboard')} />
              </span>
              <span className="textmenumobile">
                Dashboard
                {newMaintenances > 0 ? (
                  <img
                    className="img-alert-menu mobile-icon"
                    src={alertMenu}
                    alt={t('alt:notification')}
                  />
                ) : (
                  ''
                )}
              </span>
            </Link>
            <Link to={`/${locale}/${t('routers:JobsAgenda')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={schedulingWhite} alt={t('alt:maintenance_schedule')} />
              </span>
              <span className="textmenumobile">
                {t('privateMenu:jobsAgenda')}
                {newMaintenances > 0 ? (
                  <img
                    className="img-alert-menu mobile-icon"
                    src={alertMenu}
                    alt={t('alt:notification')}
                  />
                ) : (
                  ''
                )}
              </span>
            </Link>
            <Link to={`/${locale}/${t('routers:JobRequests')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={requestMaintenanceWhite} alt={t('alt:request_maintenance')} />
              </span>
              <span className="textmenumobile">{t('privateMenu:jobRequests')}</span>
            </Link>
            <Link to={`/${locale}/${t('routers:Report')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={downloadReportWhite} alt={t('alt:download')} />
              </span>
              <span className="textmenumobile">{t('privateMenu:report')}</span>
            </Link>
            <Link to={`/${locale}/${t('routers:VehiclesView')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={requestVehicleRegisWhite} alt={t('alt:vehicle_registration')} />
              </span>
              <span className="textmenumobile">{t('privateMenu:vehicleView')}</span>
            </Link>
            <Link to={`/${locale}/${t('routers:DriverRegistration')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={requestDriverRegisWhite} alt={t('alt:driver_registration')} />
              </span>
              <span className="textmenumobile">{t('privateMenu:driverRegistration')}</span>
            </Link>
            {rolId === 3 || rolId === 9 ? (
              <Link to={`/${locale}/${t('routers:UserRegistration')}`} className="mobile x2">
                <span className="iconmenumobile">
                  <img src={userWhite} alt={t('alt:users_registration')} />
                </span>
                <span className="textmenumobile">{t('privateMenu:userRegistration')}</span>
              </Link>
            ) : (
              ''
            )}

            <Link to={`/${locale}/${t('routers:QualifyService')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={approveCancelWhite} alt={t('alt:approve_qualify_service')} />
              </span>
              <span className="textmenumobile">{t('privateMenu:qualifyService')}</span>
            </Link>
            <Link to={`/${locale}/${t('routers:BenefitsCompany')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={icono3} alt={t('alt:benefits')} />
              </span>
              <span className="textmenumobile">{t('benefits')}</span>
            </Link>
            <Link to={`/${locale}/${t('routers:PlansCompany')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={icono2} alt={t('alt:plans')} />
              </span>
              <span className="textmenumobile">{t('plans-txt')}</span>
            </Link>
            <Link
              to={`/${locale}/${t('routers:Terms')}/${termAndCondition.slug}`}
              className="mobile x2"
            >
              <span className="iconmenumobile">
                <img src={icono4} alt={t('alt:termAndCondition')} />
              </span>
              <span className="textmenumobile">{t('menu:terms-condition')}</span>
            </Link>
            <Link
              to={`/${locale}/${t('routers:Terms')}/${termPoliticsPrivate.slug}`}
              className="mobile x2"
            >
              <span className="iconmenumobile">
                <img src={icono5} alt={t('alt:authorizationData')} />
              </span>
              <span className="textmenumobile border-none">{t('menu:terms-data')}</span>
            </Link>
            <Link to="" onClick={logout} className="mobile x2 close_mobile">
              <span className="iconmenumobile">
                <img src={closeWhite} alt={t('alt:logout')} />
              </span>
              <span className="textmenumobile">{t('menu:logout')}</span>
            </Link>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

InternalMenuCompany.propTypes = {
  t: PropTypes.func.isRequired,
  newMaintenances: PropTypes.number,
};

InternalMenuCompany.defaultProps = {
  newMaintenances: 0,
};

export default withTranslation(['internalMenu', 'routers', 'menu', 'privateMenu', 'alt'])(
  InternalMenuCompany
);
